import { BaseRouteService } from 'core/services';

class ClinicalStatusRouteService extends BaseRouteService {
    constructor() {
        super('clinical-statuses');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,isMasterPatient,page,rpp,sort,embed,fields}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }
    
    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }
}

export default ClinicalStatusRouteService;
